var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlockEmbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,18c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L3.9,12l4.3,4.3 c0.4,0.4,0.4,1,0,1.4C8,17.9,7.8,18,7.5,18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l4.3-4.3l-4.3-4.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5,5 c0.4,0.4,0.4,1,0,1.4l-5,5C17,17.9,16.8,18,16.5,18z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.7,21.7c-0.1,0-0.2,0-0.3,0c-0.5-0.1-0.9-0.7-0.7-1.2L13.4,3c0.1-0.5,0.7-0.8,1.2-0.7c0.5,0.1,0.8,0.7,0.7,1.2L10.6,21 C10.5,21.4,10.1,21.7,9.7,21.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockEmbed);
export default __webpack_public_path__ + "static/media/icon-block-embed.63ed1cbf8089d6f4edbd742a83c93165.svg";
export { ForwardRef as ReactComponent };